export default __webpack_public_path__ + "static/media/B93.017ace5a.png";